import { render, staticRenderFns } from "./horizontal-nav.vue?vue&type=template&id=28df18fe&scoped=true"
import script from "./horizontal-nav.vue?vue&type=script&lang=js"
export * from "./horizontal-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28df18fe",
  null
  
)

export default component.exports